import { render, staticRenderFns } from "./clicks-tab-panel.vue?vue&type=template&id=1595a306&scoped=true&"
import script from "./clicks-tab-panel.vue?vue&type=script&lang=js&"
export * from "./clicks-tab-panel.vue?vue&type=script&lang=js&"
import style0 from "./clicks-tab-panel.vue?vue&type=style&index=0&id=1595a306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595a306",
  null
  
)

export default component.exports